import { boolean, object, string } from 'yup';
import { isValidPhoneNumber } from 'libphonenumber-js';
export const loanApplicationSchema = object()
    .shape({
    phoneNumber: string().test('phone', '', (value) => {
        return !value || isValidPhoneNumber(value);
    }),
    address: string(),
    email: string().email(),
    accountNumber: string().required(),
    isGeneralConditionsAccepted: boolean().oneOf([true]).required(),
    isSpecialConditionsAccepted: boolean().oneOf([true]).required(),
    isPreContractualInformationAccepted: boolean().oneOf([true]).required(),
})
    .required();
